import breakfastSplitter from './../assets/images/Splitters/breakfastSplitter.webp'
import lunchSplitter from './../assets/images/Splitters/lunchSplitter.webp'
import dinnerSplitter from './../assets/images/Splitters/dinnerSplitter.webp'
import sundaySplitter from './../assets/images/Splitters/sundaySplitter.webp'
import snackSplitter from './../assets/images/Splitters/festiveSplitter.png'
import pizzaSplitter from './../assets/images/Splitters/pizzaSplitter.webp'
import drinkSplitter from './../assets/images/Splitters/drinkSplitter.webp'
import menuBackground from './../assets/images/Backgrounds/menuBackground.webp'
import breakfast from './../assets/pdf/breakfast.pdf'
import lunch from './../assets/pdf/lunch.pdf'
import main from './../assets/pdf/main.pdf'
import sunday from './../assets/pdf/sunday.pdf'
import snacks from './../assets/pdf/snacks.pdf'
import pizza from './../assets/pdf/pizza.pdf'
import wine from './../assets/pdf/wine.pdf'


const MenuSection = () => {
    const posts = [
      {
        id: 1,
        title: 'BREAKFAST',
        href: breakfast,
        splitter: breakfastSplitter,
        description:
          'Our breakfast menu offers a selection of traditional breakfast items. Enjoy them in your room or during our breakfast hours.',
      },
      {
        id: 2,
        title: 'LUNCH',
        href: lunch,
        splitter: lunchSplitter,
        description:
          'Our set lunch menu features 2 courses or 3 courses. Menus can change, providing a guide for what to expect on your visit.',
      },
      {
        id: 3,
        title: 'MAIN MENU',
        href: main,
        splitter: dinnerSplitter,
        description:
          'Enjoy our dinner menu with a variety of delicious dishes. Our menus can change, offering you a guide for what to expect.',
      },
      {
        id: 4,
        title: 'SUNDAY',
        href: sunday,
        splitter: sundaySplitter,
        description:
          'Enjoy our Sunday lunch featuring a selection of meats and sides. We offer options to suit your taste and dietary needs.',
      },
      {
        id: 5,
        title: 'BAR SNACKS',
        href: snacks,
        splitter: snackSplitter,
        description:
          'Enjoy our range of Bar Snacks available to order from the bar. We offer a variety of options to complement your drinks.',
      },
      {
        id: 6,
        title: 'PIZZA',
        href: pizza,
        splitter: pizzaSplitter,
        description:
          'Our pizza is made with the finest ingredients and baked in a wood-fired oven. Choose from a variety of toppings.',
      },
      {
        id: 7,
        title: 'DRINK',
        href: wine,
        splitter: drinkSplitter,
        description:
          'Quench your thirst with our selection of drinks. We offer local ales, lagers, ciders, wines, and non-alcoholic beverages to enjoy.',
      },
    ]

  return (
    <div className='w-full min-h-screen relative'>
      <img className='absolute top-0 left-0 w-full h-full object-cover z-0' src={menuBackground} alt="menu background" />
      <div className="pt-24 sm:pt-32 relative z-10">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 bg-white bg-opacity-90 backdrop-blur-md py-8 rounded-xl shadow-lg">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-4xl font-semibold tracking-widest text-pretty text-gray-900 sm:text-5xl">MENUS</h2>
            <p className="mt-2 text-lg/8 text-gray-600 tracking-widest">Breakfast / Lunch / Dinner / Pizza / Snacks / Drinks</p>
          </div>
          <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 lg:gap-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none md:grid-cols-2 lg:grid-cols-7">
            {posts.map((post) => (
              <article key={post.id} className="flex max-w-xl flex-col items-start justify-between text-center">
                <div className="group relative">
                  <h3 className="mt-3 text-lg/6 font-semibold text-gray-900 group-hover:text-gray-600 tracking-wide">
                    <a href={post.href}>    
                      <span className="absolute inset-0" />
                      {post.title}
                    </a>
                  </h3>
                  <img src={post.splitter} alt='card splitter' className='h-[20%] w-auto mx-auto mt-2'/>
                  <p className="mt-5 text-sm/6 text-gray-600">{post.description}</p>
                  <a href={post.href} className='text-sky-900 ring-1 ring-sky-800 ring-inset hover:ring-sky-800 focus-visible:outline-sky-900
                              mt-8 block rounded-md px-3.5 py-2.5 text-center text-sm font-semibold focus-visible:outline-2 focus-visible:outline-offset-2 sm:mt-10'>
                          View Menu
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
    
  )
}

export default MenuSection